<mat-drawer-container class="sidenav-container">
    <mat-drawer mode="side" opened class="sidenav bg-stc">
        <div class="flex-nowrap">
            <div class="col-auto col-md-12 col-xl-12 px-sm-12 px-3">
                <div class="d-flex flex-column align-items-center align-items-sm-start mt-3 px-1 pt-2 text-white h-100">
                    <div class="d-grid gap-2 mt-3 mb-3 text-center">
                        <span class="fs-10 d-none d-sm-inline">{{'welcome' | translate}}</span>
                        <span class="fs-10 d-none d-sm-inline"> {{Username}}</span>
                    </div>
                    <hr class="hr" />
                    <ul class="nav nav-pills flex-column align-items-center align-items-sm-start">
                        <li class="nav-item" *ngIf="isAdmin">
                            <a class="nav-link align-middle px-0 text-white d-flex align-items-center"
                                [routerLink]="'/admin/attachments'"><mat-icon class="fs-5">attachment</mat-icon><span
                                    class="ms-2 d-none d-sm-inline">{{'attachments' | translate}}</span></a>
                        </li>
                        <li class="nav-item" *ngIf="isResumeAdmin">
                            <a class="nav-link align-middle px-0 text-white d-flex align-items-center"
                                [routerLink]="'/admin/resume'"><mat-icon class="fs-5">list</mat-icon><span
                                    class="ms-2 d-none d-sm-inline">{{'resumes' | translate}}</span></a>
                        </li>

                        <li class="nav-item" *ngIf="isLogin">
                            <a class="nav-link align-middle px-0 text-white d-flex align-items-center" id="logout"
                                role="button" routerLinkActive="active" aria-expanded="false" (click)="logout()">
                                <mat-icon class="fs-5">logout</mat-icon><span class="ms-2 d-none d-sm-inline">{{
                                    "logout" | translate }}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </mat-drawer>
    <mat-drawer-content class="content">
        <router-outlet></router-outlet>
    </mat-drawer-content>
</mat-drawer-container>